import TextUpdatesPanel, { TEXT_UPDATE_PAGES as PageConstants } from './TextUpdatesPanel'

export const TEXT_UPDATE_PAGES = PageConstants
export default TextUpdatesPanel
